import React from "react";
import Topheader from '../components/Topheader';

export default function TournamentRules() {
  return (
    <>
    <Topheader colorbox="newfaq_header_color" title="Regras do Torneio" />
      <div className="container py-3">
          <ul style={{paddingLeft:"15px", fontWeight:"500"}}>
            <li>
              Os torneios começam nos horários programados e os assentos são
              atribuídos aleatoriamente.
            </li>
            <li>
              O torneio termina quando um jogador acumula todas
              as fichas do jogo.
            </li>
            <li>
              Os jogadores que perdem todas as suas fichas são eliminados
              do jogo, a menos que reentradas ou
              recompras sejam permitidas.
            </li>
            <li>
              Se dois ou mais jogadores forem eliminados na mesma
              mão, o jogador que começou a mão com mais
              fichas terminará em uma posição mais alta.
            </li>
            <li>
              O Banco de Tempo fornece tempo adicional de decisão
              que os jogadores podem usar quando necessário. O tempo
              pode ser retirado do banco até que se esgote completamente.
            </li>
            <li>
              Todas as regras padrão de torneio de pôquer se aplicam
              aos Torneios de Múltiplas Mesas (MTTs).
            </li>
            <li>
              Os torneios concedem fichas de jogo gratuitas ou Pontos de
              Recompensa como prêmios. Nenhum dinheiro real é distribuído
              em nenhuma etapa.
            </li>
            <li>
              A App Store não tem participação na organização do torneio nem
              na distribuição de Pontos de Recompensa ou fichas de jogo gratuitas como
              prêmios.
            </li>
          </ul>
        </div>
    </>
  );
}
